<a class="nav-cell d-inline-flex align-items-center" (click)="this.cellClick.emit()">
  <medrecord-ui-avatar
    [link]="avatar"
    [userId]="userId"
    medrecordAppendUserStatus
  ></medrecord-ui-avatar>
  <span class="ml-3">{{ name }}</span>
</a>